import axios from 'axios'
import src from '../context/cacheApp'
import Utils from '../utils/Utils'

const GET = 'GET'
const POST = 'POST'
const PUT = 'PUT'
const DELETE = 'DELETE'

const makeRequestApi = async (url, method, data) => {
  let storage = src.sessionApp()
  const tokenPayload = Utils.parseJwt(storage?.token?.access_token)

  if (!Utils.checkJwtExpiration(tokenPayload)) {
    await src.refreshToken().then(response => {
      if (response) {
        storage.token = response
        src.sessionApp(storage, 'setter')
      } else {
        storage = null
        src.sessionApp(null, 'remove')
      }
    })
  }

  // 🔹 Agregar un timestamp para evitar caché en GET
  if (method === GET) {
    const timestamp = new Date().getTime()
    url += url.includes('?') ? `&_t=${timestamp}` : `?_t=${timestamp}`
  }

  return await axios({
    url: url,
    method: method,
    headers: {
      Authorization: 'Bearer ' + storage?.token?.access_token,
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache, no-store, must-revalidate',
      Pragma: 'no-cache',
      Expires: '0',
    },
    data: method !== GET ? JSON.stringify(data) : undefined, // No enviar `data` en GET
  })
    .then(res => {
      if (!res || !res.data) return { errors: { message: ['Error Desconocido'] } }
      if (res.errors) return res

      return res.data
    })
    .catch(err => {
      if (err?.request.status === 0) return { errors: { message: ['Error de conexion'] } }
      if (err?.response.status === 404) return { errors: { message: ['El recurso al que intenta acceder no existe'] } }
      if (err?.response.status === 403) return { errors: { message: ['No cuenta con permisos para acceder al recurso'] } }
      if (err?.response.status === 401) {
        Utils.clearForAuthError()
        return { errors: { message: ['Debe iniciar sesión'] } }
      }
      if (err?.response?.data?.errors) return err.response.data

      return { errors: { message: [err?.response?.data?.message || err?.message || 'Error Desconocido'] } }
    })
}

const get = (url, data) => makeRequestApi(url, GET, data)
const post = (url, data) => makeRequestApi(url, POST, data)
const put = (url, data) => makeRequestApi(url, PUT, data)
const remove = (url, data) => makeRequestApi(url, DELETE, data)

export default {
  makeRequestApi,
  get,
  post,
  put,
  remove,
}
